const ComponentsLookup = {
  "default-footer": "DefaultFooter9f7353b69408404595a5Ee23c6e534ad"
}

export default ComponentsLookup;